import { call, select, put, takeLatest, all, take } from "redux-saga/effects";
import {
  createCheckoutOrderFailure,
  createCheckoutOrderStart,
  createCheckoutOrderSuccess,
  getCheckoutOrderFailure,
  getCheckoutOrderStart,
  getCheckoutOrderSuccess
} from "../actions/CheckoutAction";

import {
  getSuccessNotificationMessage,
  getErrorNotificationMessage,
} from "../../components/helper/ToastNotification";

import api from "../../components/Environment";
import { CREATE_CHECKOUT_ORDER_START, GET_CHECKOUT_ORDER_START } from "../actions/ActionConstant";

function* createCheckoutOrderAPI(action) {
  let bankAccountData = yield select((state) => state.bankAccount.bankAccount.data);
  try {
    const response = yield api.postMethodV2("bank_accounts/store", action.data);

    if (response.data.success) {
      yield put(createCheckoutOrderSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(createCheckoutOrderFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(createCheckoutOrderFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* getCheckoutOrderAPI(action) {
  try {
    const response = yield api.postMethodV2("get_order_details", action.data);

    if (response.data.success) {
      yield put(getCheckoutOrderSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(getCheckoutOrderFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(getCheckoutOrderFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

export default function* CheckoutSaga() {
  yield all([
    yield takeLatest(CREATE_CHECKOUT_ORDER_START, createCheckoutOrderAPI),
    yield takeLatest(GET_CHECKOUT_ORDER_START, getCheckoutOrderAPI),
  ])
}

